// removed by extract-text-webpack-plugin
module.exports = {"commentbtn":"_1R0-suawX5dAn-ubC5GF8T","commentbox":"gnoRT8hyq7XNDRjx0VC5C","subCommentBox":"_1Pe0C3g3EK3YA6Po0mvaUl","carregarmais":"_2ZkfEn7pmzRY4Hl_Aibc7Q","subcommentbtn":"_2UzKAuIA2nY70X2re-WgFJ","btnlink":"_3paJqzR60KshbT7bomcgEn","createComment":"_30CwIfUJ19-HmZxXN-56d-"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/organisms/Comments/style.css
// module id = 514
// module chunks = 38